import {
  FB_EMPLOYER_GET_REQUEST,
  FB_EMPLOYER_GET_SUCCESS,
  FB_EMPLOYER_GET_FAILURE,
  UPDATE_EMPLOYER_USER_REQUEST,
  UPDATE_EMPLOYER_USER_FAILURE,
  UPDATE_EMPLOYER_USER_SUCCESS,
  SAVE_EMPLOYER_SETUP_DATA_REQUEST,
  SAVE_EMPLOYER_SETUP_DATA_SUCCESS,
  SAVE_EMPLOYER_SETUP_DATA_FAILURE,
  GET_EMPLOYER_SETUP_DATA_REQUEST,
  GET_EMPLOYER_SETUP_DATA_SUCCESS,
  GET_EMPLOYER_SETUP_DATA_FAILURE,
} from '../../actions/actionTypes';
import * as types from '../../actions/actionTypes';
import { REQUESTING } from '../../actions/statusTypes';
import { __WEB__ } from '../../constants/styles';
import { currentEmployerPermissions } from '../../helpers/permissions';
import {
  BASE_SETUP_OCC_HEALTH,
  BASE_SETUP_SQ_MED_SVC_CLINICAL_LOC,
  STAFF_SCHEDULING,
} from '../../constants/permissions';

import {
  getEmployerById as getEmployerByIdService,
  acceptOrRejectEmployerAccessRequest,
  updateEmployerUser as updateEmployerUserService,
} from '../../services/employerService';
import { acceptOrRejectEmployerApptRequest as acceptOrRejectEmployerApptRequestService } from '../../services/schedulerService';

import {
  saveSetupData as saveSetupDataService,
  getSetupData as getSetupDataService,
  deleteSetupData as deleteSetupDataService,
  getOccHealthRequirements as getOccHealthRequirementsService,
  updateOccHealthRequirements as updateOccHealthRequirementsService,
  getEmployerDepartments as getEmployerDepartmentsService,
  addOccHealthDepartments as addOccHealthDepartmentsService,
  updateOccHealthDepartment as updateOccHealthDepartmentService,
  getMasterDepartments as getMasterDepartmentsService,
  deleteOccHealthDepartment as deleteOccHealthDepartmentService,
  getMedRecruiterClinicalLocations as getMedRecruiterClinicalLocationsService,
  addMedRecruiterClinicalLocations as addMedRecruiterClinicalLocationsService,
  updateMedRecruiterClinicalLocation as updateMedRecruiterClinicalLocationService,
  deleteMedRecruiterClinicalLocation as deleteMedRecruiterClinicalLocationService,
} from '../../services/employerAdminService';

export function getSetupData(employerId, dataItemsArry) {
  return function (dispatch, getState) {
    if (!currentEmployerPermissions([BASE_SETUP_SQ_MED_SVC_CLINICAL_LOC]).canView)
      return Promise.resolve(null);
    return dispatch({
      types: [
        GET_EMPLOYER_SETUP_DATA_REQUEST,
        GET_EMPLOYER_SETUP_DATA_SUCCESS,
        GET_EMPLOYER_SETUP_DATA_FAILURE,
      ],
      promise: getSetupDataService(employerId, dataItemsArry),
    });
  };
}

export function saveEmployerSetupData(employerId, itemsPath, data) {
  return {
    types: [
      SAVE_EMPLOYER_SETUP_DATA_REQUEST,
      SAVE_EMPLOYER_SETUP_DATA_SUCCESS,
      SAVE_EMPLOYER_SETUP_DATA_FAILURE,
    ],
    promise: saveSetupDataService(employerId, itemsPath, data).then((result) => {
      return {
        ...result,
        itemsPath,
      };
    }),
  };
}

export function deleteEmployerSetupData(employerId, itemsPath, itemId) {
  return {
    types: [
      SAVE_EMPLOYER_SETUP_DATA_REQUEST,
      SAVE_EMPLOYER_SETUP_DATA_SUCCESS,
      SAVE_EMPLOYER_SETUP_DATA_FAILURE,
    ],
    promise: deleteSetupDataService(employerId, itemsPath, itemId).then((result) => {
      return {
        ...result,
        itemsPath,
      };
    }),
  };
}

export function updateEmployerUser(employerId, userId, data) {
  return {
    types: [
      UPDATE_EMPLOYER_USER_REQUEST,
      UPDATE_EMPLOYER_USER_SUCCESS,
      UPDATE_EMPLOYER_USER_FAILURE,
    ],
    promise: updateEmployerUserService(employerId, userId, {
      clinical_location: data.clinicalLocation,
      medical_service: data.medicalService,
    }),
  };
}

export function getEmployerById(employerId) {
  return function (dispatch, getState) {
    if (getState().screens.employer.fetchEmployerStatus === REQUESTING) {
      return Promise.resolve();
    }
    return dispatch({
      types: [FB_EMPLOYER_GET_REQUEST, FB_EMPLOYER_GET_SUCCESS, FB_EMPLOYER_GET_FAILURE],
      promise: getEmployerByIdService(employerId),
    });
  };
}

export function acceptOrRejectEmployerInviteRequest(employerId, requestId, status) {
  return function (dispatch, getState) {
    return dispatch({
      types: [
        types.EMPLOYER_UPDATE_INVITE_REQUEST_STATUS_REQUEST,
        types.EMPLOYER_UPDATE_INVITE_REQUEST_STATUS_SUCCESS,
        types.EMPLOYER_UPDATE_INVITE_REQUEST_STATUS_FAILURE,
      ],
      promise: acceptOrRejectEmployerAccessRequest(employerId, requestId, status),
    });
  };
}

export function acceptOrRejectEmployerApptRequest(
  employerId,
  appointmentRequestId,
  status,
  reason,
  isOneOffReason
) {
  return function (dispatch, getState) {
    dispatch({
      type: types.EMPLOYER_UPDATE_PHA_REQUEST_STATUS_REQUEST,
      payload: { appointmentRequestId },
    });
    return acceptOrRejectEmployerApptRequestService(
      employerId,
      appointmentRequestId,
      status,
      reason,
      isOneOffReason
    )
      .then((result) => {
        dispatch({
          type: types.EMPLOYER_UPDATE_PHA_REQUEST_STATUS_SUCCESS,
          payload: { appointmentRequestId },
        });
      })
      .catch((e) => {
        dispatch({
          type: types.EMPLOYER_UPDATE_PHA_REQUEST_STATUS_FAILURE,
          payload: { error: { message: e?.message }, appointmentRequestId },
        });
      });
  };
}

// TODO: this is not called yet
export function removeEmployerFromRedux(employerId) {
  return { type: types.FB_EMPLOYER_LEAVE };
}

export function resetStatus() {
  return { type: types.RESET_EMPLOYER_STATUS };
}

export function getOccHealthRequirements(employerId) {
  return function (dispatch, getState) {
    if (!__WEB__ || !currentEmployerPermissions([BASE_SETUP_OCC_HEALTH]).canView)
      return Promise.resolve(null);

    return dispatch({
      types: [
        types.EMPLOYER_OCC_HEALTH_REQUIREMENTS_GET_REQUEST,
        types.EMPLOYER_OCC_HEALTH_REQUIREMENTS_GET_SUCCESS,
        types.EMPLOYER_OCC_HEALTH_REQUIREMENTS_GET_FAILURE,
      ],
      promise: getOccHealthRequirementsService(employerId),
    });
  };
}

export function getOccHealthMasterDepartments() {
  return function (dispatch, getState) {
    if (!__WEB__ || !currentEmployerPermissions([BASE_SETUP_OCC_HEALTH]).canView)
      return Promise.resolve(null);

    return dispatch({
      types: [
        types.EMPLOYER_OCC_HEALTH_MASTER_DEPARTMENTS_GET_REQUEST,
        types.EMPLOYER_OCC_HEALTH_MASTER_DEPARTMENTS_GET_SUCCESS,
        types.EMPLOYER_OCC_HEALTH_MASTER_DEPARTMENTS_GET_FAILURE,
      ],
      promise: getMasterDepartmentsService(),
    });
  };
}

export function getOccHealthDepartments(employerId) {
  return function (dispatch, getState) {
    if (!__WEB__ || !currentEmployerPermissions([BASE_SETUP_OCC_HEALTH]).canView)
      return Promise.resolve(null);
    return dispatch({
      types: [
        types.EMPLOYER_OCC_HEALTH_DEPARTMENTS_GET_REQUEST,
        types.EMPLOYER_OCC_HEALTH_DEPARTMENTS_GET_SUCCESS,
        types.EMPLOYER_OCC_HEALTH_DEPARTMENTS_GET_FAILURE,
      ],
      promise: getEmployerDepartmentsService(employerId),
    });
  };
}

export function addOccHealthDepartments(employerId, departments) {
  return function (dispatch, getState) {
    return dispatch({
      types: [
        types.EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_REQUEST,
        types.EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_SUCCESS,
        types.EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_FAILURE,
      ],
      promise: addOccHealthDepartmentsService(employerId, departments),
    });
  };
}

export function updateOccHealthDepartment(employerId, department) {
  return function (dispatch, getState) {
    return dispatch({
      types: [
        types.EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_FAILURE,
        types.EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_SUCCESS,
        types.EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_FAILURE,
      ],
      promise: updateOccHealthDepartmentService(employerId, department),
    });
  };
}

export function deleteOccHealthDepartment(employerId, department) {
  return function (dispatch, getState) {
    return dispatch({
      types: [
        types.EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_REQUEST,
        types.EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_SUCCESS,
        types.EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_FAILURE,
      ],
      promise: deleteOccHealthDepartmentService(employerId, department),
      payload: { departmentId: department.employer_department_id },
    });
  };
}

export function updateOccHealthRequirements(employerId, requirement) {
  return function (dispatch, getState) {
    return dispatch({
      types: [
        types.EMPLOYER_OCC_HEALTH_REQUIREMENTS_SAVE_REQUEST,
        types.EMPLOYER_OCC_HEALTH_REQUIREMENTS_SAVE_SUCCESS,
        types.EMPLOYER_OCC_HEALTH_REQUIREMENTS_SAVE_FAILURE,
      ],
      promise: updateOccHealthRequirementsService(employerId, requirement),
    });
  };
}

export function getMedRecruiterClinicalLocations(employerId) {
  return function (dispatch, getState) {
    if (!__WEB__ || !currentEmployerPermissions([STAFF_SCHEDULING]).canView)
      return Promise.resolve(null);
    return dispatch({
      types: [
        types.EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_GET_REQUEST,
        types.EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_GET_SUCCESS,
        types.EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_GET_FAILURE,
      ],
      promise: getMedRecruiterClinicalLocationsService(employerId),
    });
  };
}

export function addMedRecruiterClinicalLocation(employerId, location) {
  return function (dispatch, getState) {
    return dispatch({
      types: [
        types.EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_REQUEST,
        types.EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_SUCCESS,
        types.EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_FAILURE,
      ],
      promise: addMedRecruiterClinicalLocationsService(employerId, location),
    });
  };
}

export function updateMedRecruiterClinicalLocation(employerId, location) {
  return function (dispatch, getState) {
    return dispatch({
      types: [
        types.EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_REQUEST,
        types.EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_SUCCESS,
        types.EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_FAILURE,
      ],
      promise: updateMedRecruiterClinicalLocationService(employerId, location),
    });
  };
}

export function deleteMedRecruiterClinicalLocation(employerId, clinicalLocation) {
  return function (dispatch, getState) {
    return dispatch({
      types: [
        types.EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_REQUEST,
        types.EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_SUCCESS,
        types.EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_FAILURE,
      ],
      promise: deleteMedRecruiterClinicalLocationService(employerId, clinicalLocation),
    });
  };
}
